<script>
export default
{
    name: 'layout-default',
}
</script>

<template lang="pug">
    main
        justfit-header
        transition(name='page')
            router-view
        justfit-footer
</template>
